// Pastille de l'icône de l'appli installée (API Badging) : le nombre de tâches nouvelles. Le
// service worker la pose aussi à l'arrivée d'une notification groupée, appli fermée (sw.js).
// Sans effet là où le navigateur ne la connaît pas (onglet, Firefox).

type NavigateurPastille = Navigator & {
  setAppBadge?: (nombre?: number) => Promise<void>
  clearAppBadge?: () => Promise<void>
}

export function poserPastille(nombre: number): void {
  if (typeof navigator === 'undefined') return
  const n = navigator as NavigateurPastille
  const pose = nombre > 0 ? n.setAppBadge?.(nombre) : n.clearAppBadge?.()
  // Refus du navigateur (permission de notification absente) : la pastille dans l'appli suffit.
  void pose?.catch(() => undefined)
}
